import ReactPlayer from "react-player";
import classes from "./instructionalVideo.module.css";
const InstructionalVideo = ({ formType, logAppUse }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "50%",
      }}
    >
      <ReactPlayer
        config={{
          vimeo: {
            playerOptions: {
              controls: true,
            },
          },
        }}
        onPlay={() => {
          formType === "assessment"
            ? logAppUse(
                "criteria_selection_assessment",
                "assessment_video_play"
              )
            : formType === "reading"
            ? logAppUse(
                "criteria_selection_reading_comprehension",
                "reading_comprehension_video_play"
              )
            : logAppUse(
                "criteria_selection_grading",
                "grading_video_play"
              );
        }}
        controls={true}
        className={`${classes.reactPlayerClass} ${classes.reactPlayerVideo} ${classes.customVideoClass} `}
        url={
          formType === "assessment"
            ? `https://vimeo.com/899973456`
            : formType === "reading"
            ? `https://vimeo.com/899987329`
            : `https://vimeo.com/1005809400`
        }
        playing={false}
      />
    </div>
  );
};

export default InstructionalVideo;
